__turbopack_context__.v({
  "header": "profiles-module-scss-module__Q2v4xG__header",
  "headerRightSide": "profiles-module-scss-module__Q2v4xG__headerRightSide",
  "missingSomething": "profiles-module-scss-module__Q2v4xG__missingSomething",
  "profilesGrid": "profiles-module-scss-module__Q2v4xG__profilesGrid",
  "profilesList": "profiles-module-scss-module__Q2v4xG__profilesList",
  "profilesWrapper": "profiles-module-scss-module__Q2v4xG__profilesWrapper",
  "searchInput": "profiles-module-scss-module__Q2v4xG__searchInput",
  "spinner": "profiles-module-scss-module__Q2v4xG__spinner",
  "title": "profiles-module-scss-module__Q2v4xG__title",
  "viewTypeButton": "profiles-module-scss-module__Q2v4xG__viewTypeButton",
  "viewTypeButtonActive": "profiles-module-scss-module__Q2v4xG__viewTypeButtonActive",
  "wrapper": "profiles-module-scss-module__Q2v4xG__wrapper",
  "zeroCase": "profiles-module-scss-module__Q2v4xG__zeroCase",
});
